import React from 'react'
import { Icon } from 'antd'

import {
  getPhaseStatus,
  getPhaseView,
  getStatusLabel,
  isPhaseSelectable
} from '../../utils'
import './ProgressPreview.scss'

const ProgressPreview = ({
  phaseSteps,
  currentPhase,
  expandedPhases,
  progressPercent,
  isFinalized,
  onPhaseSelect
}) => {
  const activeIndex = isFinalized
    ? phaseSteps.length - 1
    : Math.max(0, phaseSteps.findIndex(step => step.key === currentPhase))

  return (
    <nav
      className="creative-direction-chat__process"
      aria-label="Creative direction progress"
    >
      <div className="creative-direction-chat__phase-rail">
        {/* Continuous timeline track line */}
        <div className="creative-direction-chat__phase-line-track">
          <div
            className="creative-direction-chat__phase-line-fill"
            style={{ width: `${(activeIndex / (phaseSteps.length - 1)) * 100}%` }}
          />
        </div>

        {phaseSteps.map((step, index) => {
          const view = getPhaseView(step.key)
          const status = getPhaseStatus({
            phaseSteps,
            currentPhase,
            phase: step.key,
            isFinalized
          })
          const canSelect = isPhaseSelectable({
            phaseSteps,
            currentPhase,
            phase: step.key,
            isFinalized
          })
          const isSelected = Boolean(expandedPhases[step.key])

          return (
            <button
              type="button"
              className={`creative-direction-chat__phase-step creative-direction-chat__phase-step--${status}${
                isSelected
                  ? ' creative-direction-chat__phase-step--selected'
                  : ''
              }`}
              disabled={!canSelect}
              key={step.key}
              onClick={() => canSelect && onPhaseSelect(step.key)}
            >
              <span className="creative-direction-chat__phase-step-node">
                {status === 'complete' ? <Icon type="check" /> : index + 1}
              </span>
              <span className="creative-direction-chat__phase-step-copy">
                <strong>{view.shortLabel}</strong>
                <small>{getStatusLabel(status)}</small>
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}

export default ProgressPreview
